module.exports = __webpack_public_path__ + "static/img/place-bid.2afa0958.svg";